export const BOX_3 = require('./box3.png'); 
export const BOX_3_Title = require('./box3_title.png'); 
export const LEFT_CHARACTER = require('./left_character.png'); 
export const RIGHT_CHARACTER = require('./right_character.png'); 

export const user1_bg =require('./A/1.png');
export const user2_bg =require('./A/2.png');
export const user3_bg =require('./A/3.png');
export const user4_bg =require('./A/4.png');
export const user5_bg =require('./A/5.png');
export const user6_bg =require('./A/6.png');
export const user7_bg =require('./A/7.png');
export const user8_bg =require('./A/8.png');
export const user9_bg =require('./A/9.png');

export const user1_bg_active =require('./B/1.png');
export const user2_bg_active =require('./B/2.png');
export const user3_bg_active =require('./B/3.png');
export const user4_bg_active =require('./B/4.png');
export const user5_bg_active =require('./B/5.png');
export const user6_bg_active =require('./B/6.png');
export const user7_bg_active =require('./B/7.png');
export const user8_bg_active =require('./B/8.png');
export const user9_bg_active =require('./B/9.png');

export const instange=require('./A/button_ig.png');
export const instange_active=require('./B/button_ig.png');
export const twitter=require('./A/button_twitter.png');
export const twitter_active=require('./B/button_twitter.png');
export const tip=require('./tip.png');
